





































































import { Component, Vue } from 'vue-property-decorator'

import container from '@/components/page/page-container.vue'
import emailForm from '@/components/footer/email-form.vue'

@Component({
  components: {
    container,
    emailForm,
  },
})
export default class extends Vue {}
